import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  logEvent(
    eventName: string,
    eventCategory: string,
    eventAction: string,
    options: object = {},
    eventLabel: string = null,
    eventValue: number = null
  ): void {
    gtag('event', eventName, {
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      eventValue: eventValue,
      ...options,
    });
  }

  logPageView(url: string): void {
    gtag('config', environment.ga.trackId, { page_path: url });
  }

  setParams(params): void {
    gtag('set', params);
  }
}
